import Stack from '@mui/material/Stack';
import { colors, IconButton, Tooltip, Typography } from '@sweep-io/sweep-design';
import { DocumentationTabTypes } from './types';
import { ChevronRight, Close } from '@sweep-io/sweep-design/dist/icons';
import { getMetadataLabel } from './getMetadataLabel';

interface TabListItemProps {
  tab: DocumentationTabTypes;
  handleTabChange: (tabId: string) => void;
  onRemoveMetadata: (tabId: string) => void;
}

export const TabListItem = ({ tab, handleTabChange, onRemoveMetadata }: TabListItemProps) => {
  return (
    <Stack
      key={tab.id}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        cursor: 'pointer',
        borderBottom: `1px solid ${colors.grey[120]}`,
        padding: '12px 16px 12px 24px',
        '& .remove-metadata-button': {
          display: 'none',
        },
        '&:hover': {
          backgroundColor: colors.grey[100],

          '& .remove-metadata-button': {
            display: tab._isNotRemovable ? 'none' : 'flex',
          },
          '& .chevron-right-metadata-button': {
            display: tab._isNotRemovable ? 'flex' : 'none',
          },
        },
        '& .chevron-right-metadata-button': {
          display: 'flex',
        },
      }}
      onClick={() => handleTabChange(tab.id)}
    >
      <Typography variant="body-medium" color={colors.black}>
        {getMetadataLabel(tab.label)}
      </Typography>
      <Stack className="remove-metadata-button">
        <Tooltip placement="top" title="Remove metadata">
          <IconButton
            variant="flat"
            size="tiny"
            onClick={(e) => {
              e.stopPropagation();
              onRemoveMetadata(tab.id);
            }}
          >
            <Close />
          </IconButton>
        </Tooltip>
      </Stack>
      <Stack className="chevron-right-metadata-button">
        <IconButton variant="flat" size="tiny">
          <ChevronRight size="medium" />
        </IconButton>
      </Stack>
    </Stack>
  );
};
